import React, {useEffect} from "react";
import { BrowserRouter, Switch, Route } from "react-router-dom";

import {useImmerReducer} from 'use-immer'
import {auth, firestore} from './firebase'

import StateContext from './StateContext'
import DispatchContext from './DispatchContext'
import FlashMessages from './components/FlashMessages/FlashMessages'

import "./index.css";
import Home from './components/Home/Home'
import Header from './components/Header/Header'
import Footer from './components/Footer/Footer'

import Loader from './components/Loader/Loader'

// MEDIA
import AddMedia from './components/Media/AddMedia'

// Custom components

import AuthPage from "./pages/AuthPage";
import ProfilePage from "./pages/ProfilePage";
import EditProfilePage from "./pages/EditProfilePage";
import EditBudgetElement from "./components/User/UserFinances/EditBudgetElement";
import LoanCalculatorPage from "./pages/LoanCalculatorPage";
import BoligPrisKalkulatorPage from "./pages/BoligPrisKalkulatorPage";
import AdminPage from "./pages/AdminPage";
import { useState } from "react";
import CurrencyPage from "./pages/CurrencyPage";

function App() {

    const [isLoading, setIsLoading] = useState(true)


    const initialState = {
        loggedIn: false,
        userId: "",
        userData: {
            profile_image: "",
            name: ""
        },
        flashMessages: [],
        isSearchOpen: false,
        darkBackground: false,
        currentPage: "home"
    }

    function ourReducer(draft, action) {
        switch (action.type) {
            case "login":
                draft.loggedIn = true
                draft.userId = action.value
                return
            case "userName":
                draft.userData.name = action.value
                return
            case "userAvatar":
                draft.userData.profile_image = action.value 
                return
            case "logout":
                draft.loggedIn = false
                return
            case "flashMessage":
                draft.flashMessages.push(action.value)
                return 
            case "currentPage":
                draft.currentPage = action.value
                return
            case "openSearch":
                draft.isSearchOpen = true
                return
            case "closeSearch":
                draft.isSearchOpen = false
                return            
            case "openModal":
                draft.darkBackground = true
                return
            case "closeModal":
                draft.darkBackground = false
                return
        }
    }
    const [state, dispatch] = useImmerReducer(ourReducer, initialState);

    useEffect(() => {

        auth.onAuthStateChanged((user) => {
            if (user) {
                dispatch({type: "login", value: user.uid});
            } 
            
        })
        setIsLoading(false)

    }, [])

    useEffect(() => {

        if (state.loggedIn && state.userId) {

            try {
                const authorRef = firestore.collection("authors");
                authorRef.where("user_id", "==", state.userId).onSnapshot(({docs}) => {
                    const author = docs.map(doc => {
                        return {id: doc.id, ...doc.data()}
                    })
                    if (author.length) {
                        //console.log(author[0], "author App.js")
                        localStorage.setItem("myRecipesUserAvatar", author[0].profile_image)
                        localStorage.setItem("myRecipesUserName", author[0].name)
                        dispatch({type: "userAvatar", value: author[0].profile_image})
                        dispatch({type: "userName", value: author[0].name})
                    }

                })
            } catch (error) {
                
            }

        }

    }, [state.loggedIn, state.userId])

    return (
      <StateContext.Provider value={state}>
      <DispatchContext.Provider value={dispatch}>
      <BrowserRouter>
      <FlashMessages messages={state.flashMessages} />
        <Header />
            {isLoading && <Loader />}
          <Switch>

            <Route path="/" exact>
                <Home/>
            </Route>

            <Route path="/login" exact>
                <AuthPage />
            </Route>

            <Route path="/add-media" exact>
                <AddMedia />
            </Route>

            <Route path="/lanekalkulator" exact>
                <LoanCalculatorPage />
            </Route>

            <Route path="/boligpriskalkulator" exact>
                <BoligPrisKalkulatorPage />
            </Route>

            <Route path="/currencies" exact>
                <CurrencyPage />
            </Route>

            <Route path="/member/:id" exact>
                <ProfilePage />
            </Route>


            <Route path="/budget/edit/:id" exact>
                <EditBudgetElement />
            </Route>


            <Route path="/member/edit/:id" exact>
                <EditProfilePage />
            </Route>

            <Route path="/admin" exact>
                <AdminPage />
            </Route>

          </Switch>
          <Footer />
      </BrowserRouter>
      </DispatchContext.Provider>
      </StateContext.Provider>
    );

}

export default App;
